export const REPORTING_USERS = ["skaiser@meetyoo.de", "erudisch@meetyoo.de"];

export default REPORTING_USERS;
